import Vue from 'vue'
import config from '@/config/index'

export default {
  namespaced: true,
  state: {
    loadingStatus: false,
    personItems: [],
    personData: {
      personName: {},
      personType: {}
    },
    prenameThItems: ['', 'นาย', 'นาง', 'นางสาว', 'อาจารย์', 'ดร.', 'ศ.ดร.', 'ศ.', 'ผศ.ดร.', 'ผศ.', 'รศ.ดร.', 'รศ.', 'ว่าที่ ร.ต.', 'คุณ'],
    prenameEnItems: ['', 'Mr.', 'Mrs.', 'Miss', 'Aj.', 'Dr.', 'Asst. Prof. Dr.'],
    educationLevelItems: [],
    totalItems: 0,
    roleItems: [
      { "id": 1, "authority": "ROLE_ADMIN" },
      { "id": 2, "authority": "ROLE_VIEWER" }
    ]
  },
  getters: {
    educationLevelItems (state) {
      return state.educationLevelItems
    },
    loadingStatus (state) {
      return state.loadingStatus
    },
    personItems (state) {
      return state.personItems
    },
    personData (state) {
      return state.personData
    },
    prenameThItems (state) {
      return state.prenameThItems
    },
    prenameEnItems (state) {
      return state.prenameEnItems
    },
    roleItems (state) {
      return state.roleItems
    },
    totalItems (state) {
      return state.totalItems
    },
    uploadUrl: (state) => {
      return `${config.serverURI}/persons/upload`
    },
    uploadEducationUrl: (state) => {
      return `${config.serverURI}/educations/upload`
    }
  },
  mutations: {
    SET_EDUCATION_LEVEL_ITEMS (state, payload) {
      state.educationLevelItems = payload
    },
    SET_LOADING_STATUS (state, payload) {
      state.loadingStatus = payload
    },
    SET_PERSON_DATA (state, payload) {
      state.personData = payload
    },
    setPersonData (state, payload) {
      state.personData = payload
    },
    setPersonItems (state, payload) {
      state.personItems = payload
    },
    resetPersonData (state) {
      state.personData = {
        personName: {}
      }
    },
    SET_PERSON_ITEMS (state, payload) {
      state.personItems = payload
    },
    SET_TOTAL_ITEMS (state, payload) {
      state.totalItems = payload
    }
  },
  actions: {
    fetchPerson (context, payload) {
      // console.log('actions fetchPerson')
      context.commit('SET_LOADING_STATUS', true)
      Vue.axios.get(`${config.serverURI}/persons/${payload}`).then((response) => {
        // console.log('fetchPerson', response.data)
        context.commit('SET_PERSON_DATA', response.data)
      }).catch((error) => {
        // console.log(error)
        context.commit('SET_LOADING_STATUS', false)
      })
    },
    fetchPersons ({ commit, dispatch }, payload) {
      // console.log('actions fetchPersons')
      Vue.axios.get(`${config.serverURI}/persons/page`, { params: payload }).then((response) => {
        // console.log('persons', response.data)
        commit('setPersonItems', response.data.items)
      }).catch((error) => {
        // console.log(error)
        dispatch('snackbarOnLoadFail', error)
      })
    },
    fetchAllPerson ({ commit, dispatch }, payload) {
      // console.log('actions fetchAllPerson')
      Vue.axios.get(`${config.serverURI}/persons`).then((response) => {
        // console.log('persons', response.data)
        commit('setPersonItems', response.data)
      }).catch((error) => {
        // console.log(error)
        dispatch('snackbarOnLoadFail', error)
      })
    },
    fetchPersonItems (context, payload) {
      console.log('actions fetchPersonItems')
      context.commit('SET_LOADING_STATUS', true)
      Vue.axios.get(`${config.serverURI}/persons/list`).then((response) => {
        // // console.log('persons', response.data)
        context.commit('SET_LOADING_STATUS', false)
        context.commit('SET_PERSON_ITEMS', response.data)
      }).catch((error) => {
        // console.log(error)
        context.commit('SET_LOADING_STATUS', false)
        context.dispatch('snackbarOnLoadFail', error)
      })
    },
    savePerson ({ commit, dispatch }, payload) {
      // console.log('actions savePerson')
      return new Promise((resolve, reject) => {
        Vue.axios.post(`${config.serverURI}/persons`, payload).then((response) => {
          // console.log('on save person', response)
          dispatch('snackbarOnSaveSuccess')
          dispatch('fetchPersons')
          resolve(response)
        }).catch((error) => {
          // console.log('savePerson', error)
          reject(error)
          dispatch('snackbarOnLoadFail', error)
        })
      })
    },
    resetPersonData ({commit}) {
      commit('resetPersonData')
    },
    loadItems ({ commit, dispatch }, payload) {
      // console.log('-> loadItems')
      return Vue.axios.get(`${config.serverURI}/persons`)
    },
    loadItemsAsPage ({ commit, dispatch }, pagination) {
      // console.log('-> loadItemsAsPage', pagination)
      return Vue.axios.get(`${config.serverURI}/persons/page`, { params: pagination })
    },
    loadItemsAsInstructor ({ commit, dispatch }, payload) {
      // console.log('-> loadItemsAsInstructor')
      return Vue.axios.get(`${config.serverURI}/persons/personAsInstructor`)
    },
    create ({ commit, dispatch }, payload) {
      // console.log('-> create', payload)
      return Vue.axios.post(`${config.serverURI}/persons`, payload)
    },
    update ({ commit, dispatch }, payload) {
      // console.log('-> update', payload)
      return Vue.axios.put(`${config.serverURI}/persons/${payload.id}`, payload)
    },
    delete ({ commit, dispatch }, payload) {
      // console.log('-> delete', payload)
      return Vue.axios.delete(`${config.serverURI}/persons/${payload.id}`)
    },
    deleteFile ({ commit, dispatch }, payload) {
      // console.log('-> deleteItem', payload)
      return Vue.axios.put(`${config.serverURI}/persons/deleteFile?id=${payload.id}&documentType=${payload.documentType}`)
    },
    loadEducationLevelItems (context) {
      // console.log('actions loadEducationLevelItems')
      context.commit('SET_LOADING_STATUS', true)
      Vue.axios.get(`${config.serverURI}/educationLevels`).then((response) => {
        // console.log('fetchPerson', response.data)
        context.commit('SET_EDUCATION_LEVEL_ITEMS', response.data)
      }).catch((error) => {
        // console.log(error)
        context.commit('SET_LOADING_STATUS', false)
      })
    },
    createEducation ({ commit, dispatch }, payload) {
      // console.log('-> createEducation', payload)
      return Vue.axios.post(`${config.serverURI}/educations`, payload)
    },
    updateEducation ({ commit, dispatch }, payload) {
      // console.log('-> updateEducation', payload)
      return Vue.axios.put(`${config.serverURI}/educations/${payload.id}`, payload)
    },
    deleteEducation ({ commit, dispatch }, payload) {
      // console.log('-> deleteEducation', payload)
      return Vue.axios.delete(`${config.serverURI}/educations/${payload.id}`)
    },

    createItem ({ commit, dispatch }, payload) {
      // console.log('-> createItem', payload)
      return Vue.axios.post(`${config.serverURI}/${payload.dispatch}`, payload)
    },
    updateItem ({ commit, dispatch }, payload) {
      console.log('-> updateItem', payload.id)
      return Vue.axios.put(`${config.serverURI}/${payload.dispatch}/${payload.id}`, payload)
    },
    deleteItem ({ commit, dispatch }, payload) {
      // console.log('-> deleteItem', payload)
      return Vue.axios.delete(`${config.serverURI}/${payload.dispatch}/${payload.id}`)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/person.js